module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/lyn_clone/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/lib/jenkins/workspace/lyn_clone/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
